import React, { useEffect, useRef, useState } from 'react';
import api from '../api/api';

export function CrmHistoryIcon() {
  return <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 11a9 9 0 1 1 2.6 7M3 4v7h7M12 7v5l3 2" /></svg>;
}

export default function CustomerCrmHistory({ endpoint, messageId, onClose }) {
  const dialog = useRef(null);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const element = dialog.current;
    element.showModal();
    // StrictMode replays this effect. Its queued close event must not dismiss
    // the reopened modal; only the Close button and Escape notify the parent.
    return () => element.close();
  }, []);
  useEffect(() => {
    let current = true;
    setLoading(true); setError('');
    api.get(`${endpoint}${messageId ? `/${messageId}` : ''}/history`)
      .then(({ data }) => { if (current) setRows(data); })
      .catch(err => { if (current) setError(err.response?.data?.error || 'Unable to load message history.'); })
      .finally(() => { if (current) setLoading(false); });
    return () => { current = false; };
  }, [endpoint, messageId, retry]);
  const labels = { created: 'Message added', edited: 'Message edited', deleted: 'Message deleted', snapshot: 'Starting snapshot' };
  return <dialog ref={dialog} className="crm-history-modal" aria-labelledby="crm-history-title" onCancel={onClose}>
    <header><div><h3 id="crm-history-title">{messageId ? 'Message history' : 'CRM history'}</h3><p>Newest changes first · All times Eastern</p></div><button type="button" className="crm-history-close" onClick={onClose} title="Close" aria-label="Close history" autoFocus><span aria-hidden="true">x</span></button></header>
    <div className="crm-history-content" aria-busy={loading}>
      {loading ? <p>Loading history...</p> : error ? <div role="alert"><p>{error}</p><button type="button" onClick={() => setRetry(value => value + 1)}>Retry</button></div> : rows.length === 0 ? <p>No history available.</p> : rows.map(row => <article key={row.id} className="crm-history-entry">
        <div className="crm-meta"><strong>{labels[row.action] || row.action} · {row.actorName}</strong><time dateTime={row.changedAt}>{new Date(row.changedAt).toLocaleString('en-US', { timeZone: 'America/New_York', dateStyle: 'medium', timeStyle: 'medium' })}</time></div>
        <small>Message #{row.messageId} · Version {row.version}</small>
        {row.action === 'snapshot' && <p className="crm-history-notice">Earlier revisions were not recorded. This is the last saved text when history tracking began.</p>}
        {row.beforeBody !== null && <div><h4>{row.action === 'deleted' ? 'Deleted message' : 'Before'}</h4><p className="crm-body">{row.beforeBody}</p></div>}
        {row.afterBody !== null && <div><h4>{row.action === 'edited' ? 'After' : 'Message'}</h4><p className="crm-body">{row.afterBody}</p></div>}
      </article>)}
    </div>
  </dialog>;
}
